export {default as timeFormatDefaultLocale, timeFormat, timeParse, utcFormat, utcParse} from "./src/defaultLocale";
export {default as timeFormatLocale} from "./src/locale";
export {default as isoFormat} from "./src/isoFormat";
export {default as isoParse} from "./src/isoParse";



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-time-format/index.js
// module id = ../../../../d3-time-format/index.js
// module chunks = 3